// extracted by mini-css-extract-plugin
module.exports = {"customSelect":"select_customSelect__USH_h","disabled":"select_disabled__qjuyI"};